import { ClotureTab } from "@features/production/components/ClotureTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FolderCheck } from "lucide-react";

export const Route = createFileRoute("/_app/production/cloture/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.CLOTURE.VIEW),
  staticData: {
    title: "Clôture",
    icon: FolderCheck,
    tab_icon: FolderCheck,
    permission: PERMISSIONS.PRODUCTION.CLOTURE.VIEW,
    section: "App",
    module: "production",
    order: 60,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Clôture des ordres de fabrication",
  },
  component: ClotureTab,
});
